export const markers = {
  USA: {
    lng: -122.398559,
    lat: 37.7888956,
  },
  Poland: {
    lng: 20.986031099330717,
    lat: 52.23421983438129,
  },
  Argentina: {
    lng: -58.3853582,
    lat: -34.6040643,
  },
};

export const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;

export const INITIAL_MAP_ZOOM = 1;
export const INITIAL_MAP_MOBILE_ZOOM = 0.6;
export const INITIAL_MAP_LNG = -40.539046499999266;
export const INITIAL_MAP_LAT = 17.515557952842894;
